// extracted by mini-css-extract-plugin
module.exports = {"grid":"BackgroundImage_grid__2CZje","bg":"BackgroundImage_bg__3nfL9","container":"BackgroundImage_container__39jcq"};